export enum CustomStorefrontsIds {
  nearby = "-1",
  newsfeed = "-2",
  allBrands = "-3",
}
